import numeral from 'numeral'

// locale FR pour les nombres
numeral.register('locale', 'fr', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème'
  },
  currency: {
    symbol: '€'
  }
})

// switch between locales
numeral.locale('fr')

/**
 *
 * @param number
 * @param precision
 * @returns {string} number formatté natif (en)
 */
const round = function (number, precision) {

  let formattedNumber = number
  if (number || number === 0) {
    number = number.toString().replace(/\.|,/g, '.')
    formattedNumber = Number.parseFloat(number).toFixed(precision)
  }
  return formattedNumber.replace(/\./g, ',')
}

/**
 * Arrondit le nombre passé s'il s'agit d'un vrai nombre non null.
 * @param number
 * @param precision nb de chiffres significatifs à garder
 * @param ratio ratio de conversion à appliquer avant l'arrondi
 * @returns {string} number formatté natif (en)
 */
const formatNumber = function (number, precision, ratio = 1) {

  let formattedNumber = number
  if (number !== undefined && number !== null && typeof (number) === 'number') {
    formattedNumber = (number * ratio).toString().replace(/\.|,/g, '.')
    formattedNumber = Number.parseFloat(formattedNumber).toFixed(precision)
    if (formattedNumber === '-0') {
      formattedNumber = '0'
    }
    return formattedNumber.replace(/\./g, ',')
  }

  return formattedNumber
}

/**
 *
 * @param number
 * @param precision
 * @returns {string} nombre formatté en français
 */
const formatDecimal = function (number, precision = 2) {
  return (number || number === 0) ? round(number, precision).replace(/\./g, ',') : number
}

/**
 *
 * @param {*} value un nombre
 * @returns {string} nombre formaté avec séparateur de milliers
 */
const split = function (value) {
  //'\xa0' => code de l'espace insécable pour vueJS
  return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0') : value
}

export default {
  round,
  formatNumber,
  formatDecimal,
  split
}
